// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutThisEventEmbedded_container__wdFiD","hidden":"AboutThisEventEmbedded_hidden__SLlIE"};